var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Menu'),_c('NavigationBar',{attrs:{"back-link":"/","back-text":"Home"}}),_c('Accommodation'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }